<template>
    <b-col cols=12>
        <b-card no-body class='pt-2 w-100'>

            <b-list-group flush style='min-height: 135px;'>
                <div v-if="items.length === 0" style="height: 135px; display: flex; justify-content: center; align-items: center;">
                    <h6 class='mb-0 txt-color-primary'>The list is empty</h6>
                </div>
                <b-list-group-item
                    style='background: none;'
                    button
                    v-for="(item, index) in items" v-bind:key="index"
                >
                    <b-row>
                        <b-col cols=12 sm=6 class='pr-sm-0 txt-color-secondary text-sm-left' style="text-align: right;">
                            <p class='mb-0'>{{ getRegistro(item.block_timestamp) }}</p>
                        </b-col>
                        <b-col cols=12 sm=6 class='pl-sm-0 txt-color-primary'>
                            <b-row class='text-right'>
                                <b-col cols=12 >
                                    <h6 class='mb-0'>
                                        {{item.sgb}}
                                        <span v-if="item.account == undefined" >SGB</span>
                                        <span v-else>{{item.account}}</span>
                                    </h6>
                                </b-col>
                                <b-col v-if="item.cost != undefined" cols=12  style="color: #A7A4A4; font-size: 0.8rem;">
                                    <h6 class='mb-0' style='font-size: 0.8rem'>Cost {{item.cost}}<span class='pl-1'>{{base}}</span></h6>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </b-list-group>
            <b-card-body class='text-right'>
               <b-button class = "btn-sm" style="height: 27px;" variant="primary">+</b-button>
            </b-card-body>
        </b-card>
    </b-col>
</template>
<script>
export default {
  props: [
    'items',
    'base'
  ],
  methods: {
    getRegistro (timestamp) {
      return new Date(timestamp).toLocaleString()
    }
  }
}
</script>
<style>
.card {
    background-color: #1E1E1E !important;
    border-radius: 0.5rem !important;
}
.txt-color-primary {
    color: #FFF9BC;
    font-family: "Poppins-Light";
}
.txt-color-secondary {
    color: #FFFFFF;
    font-family: "Poppins-Light";
}
</style>
